import "./EBikeRental.module.css";
import Header from "@/reusable_sections/Header";
import LimitedEditionCookies from "./sections/LimitedEditionCookies";
import ConsultingWorkflow from "./sections/ConsultingWorkflow";
import FooterBikeLux from "@/reusable_sections/Footer";
export default function EBikeRentalPage() {
  return <div>
      <Header />
      <LimitedEditionCookies />
      <ConsultingWorkflow />
      <FooterBikeLux />
    </div>;
}